module.exports = __webpack_public_path__ + "img/logo.c3f5ff4d.png";